import { useCallback, useState } from 'react'
//
import { FullWidthPrimaryButton, TextError } from 'commonStyledComponents'
import { postGamePaySecurity } from 'api/index'
import { useFormik } from 'formik'
import * as Yup from 'yup'

import { Wrapper, FormRow, Input } from './Styled'
import {
  withdrawBankBranchNameValidator,
  withdrawBankNameValidator,
  withdrawCardCodeValidator,
  withdrawLegalNameValidator,
} from 'utils/formValidators'

interface CreateWithdrawAccountProps {
  onSuccess: () => void
}

export default function CreateWithdrawAccount({ onSuccess }: CreateWithdrawAccountProps) {
  const [errorMessage, setErrorMessage] = useState<string>('')
  const [loading, setLoading] = useState<boolean>(false)

  const { values, errors, handleChange, handleBlur, handleSubmit, isValid, dirty, touched, setFieldValue } = useFormik({
    initialValues: {
      legalName: '',
      bankName: '',
      cardCode: '',
      branchName: '',
    },
    // validateOnChange: false,
    validationSchema: Yup.object().shape({
      legalName: withdrawLegalNameValidator,
      bankName: withdrawBankNameValidator,
      cardCode: withdrawCardCodeValidator,
      branchName: withdrawBankBranchNameValidator,
    }),
    onSubmit: async () => {
      if (loading) return
      setLoading(true)
      try {
        await submit()
      } finally {
        setLoading(false)
      }
    },
  })

  const handleLegalNameInput = useCallback(
    (e: React.FormEvent<HTMLInputElement>) => {
      const value = (e.target as HTMLInputElement).value
      if (/[・.]/gi.test(value)) {
        setFieldValue('legalName', value.replaceAll(/[・.]/g, '·'))
      } else {
        handleChange(e as any)
      }
    },
    [handleChange, setFieldValue]
  )

  // 過濾空白字元
  const handleAccountInput = useCallback(
    (e: React.FormEvent<HTMLInputElement>) => {
      const value = (e.target as HTMLInputElement).value
      if (/\s+/gi.test(value)) {
        setFieldValue('cardCode', value.replaceAll(/\s/g, ''))
      } else {
        handleChange(e as any)
      }
    },
    [handleChange, setFieldValue]
  )

  const submit = async () => {
    const payload = {
      account: values.cardCode,
      bankName: values.bankName,
      branchName: values.branchName,
      legalName: values.legalName,
      remittanceType: 1, // bank
    }
    payload.account = payload.account.replaceAll(/\s/g, '')
    try {
      setErrorMessage('')
      await postGamePaySecurity(payload)
      onSuccess()
    } catch (ex: any) {
      console.warn(ex)
      setErrorMessage(ex.message)
    }
  }

  return (
    <Wrapper>
      <FormRow>
        <span>真实姓名</span>
        <Input name="legalName" value={values.legalName} onInput={handleLegalNameInput} onBlur={handleBlur}></Input>
      </FormRow>
      <TextError>{touched.legalName && errors.legalName}</TextError>
      <FormRow>
        <span>银行名称</span>
        <Input name="bankName" value={values.bankName} onInput={handleChange} onBlur={handleBlur}></Input>
      </FormRow>
      <TextError>{touched.bankName && errors.bankName}</TextError>
      <FormRow>
        <span>银行卡号</span>
        <Input name="cardCode" value={values.cardCode} onInput={handleAccountInput} onBlur={handleBlur}></Input>
      </FormRow>
      <TextError>{touched.cardCode && errors.cardCode}</TextError>
      <FormRow>
        <span>开户支行</span>
        <Input name="branchName" value={values.branchName} onInput={handleChange} onBlur={handleBlur}></Input>
      </FormRow>
      <TextError>{touched.branchName && errors.branchName}</TextError>
      <TextError>{errorMessage}</TextError>
      <FullWidthPrimaryButton type="submit" onClick={() => void handleSubmit()} disabled={!isValid || !dirty}>
        确定送出
      </FullWidthPrimaryButton>
    </Wrapper>
  )
}
